import { cn } from "@src/lib/utils/cn";

/**
 * Shared chrome for the InlineEdit* fields so the read row, the in-place
 * editor and the option popovers stay on one look. Documented under
 * "## Inline edit" in design.md.
 */

// Read row hover / keyboard focus (InlineEditButton).
export const INLINE_EDIT_ROW_INTERACTIVE_CLASSNAME =
  "cursor-pointer transition-colors duration-[200ms] ease-[cubic-bezier(0.45,0.25,0.25,1)] hover:bg-state-hover focus-visible:bg-state-hover focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-brand-border";

// Text / email / phone editors that replace the read row in place: a
// focused field (brand border + Button's 3px brand-border ring).
export const INLINE_EDIT_EDITOR_CLASSNAME =
  "rounded-lg border border-brand bg-bg-primary ring-[3px] ring-brand-border";

// Added to the editor while its save error is showing.
export const INLINE_EDIT_EDITOR_ERROR_CLASSNAME =
  "border-status-error-solid ring-status-error-border";

// Bare control inside an editor: no chrome of its own.
export const INLINE_EDIT_CONTROL_CLASSNAME =
  "border-none bg-transparent font-sans-v4 text-s-v4 font-normal-v4 text-text-primary shadow-none outline-none placeholder:text-text-tertiary";

// Single-select, multi-select and calendar popovers that open over the row.
export const INLINE_EDIT_POPOVER_CLASSNAME =
  "rounded-lg border border-border-primary bg-bg-elevated text-text-primary shadow-large outline-none";

// Top row of a popover (current value or search, plus the saving spinner).
export const INLINE_EDIT_POPOVER_HEADER_CLASSNAME =
  "border-b border-border-primary";

// Small group label above the options.
export const INLINE_EDIT_GROUP_LABEL_CLASSNAME =
  "block pb-1 pl-2 pr-1 text-text-tertiary";

// One selectable option row.
export const INLINE_EDIT_OPTION_CLASSNAME = cn(
  "block self-stretch p-2 transition-[background-color] duration-150 ease-[cubic-bezier(0.45,0.25,0.25,1)]",
  "hover:cursor-pointer hover:bg-state-hover focus:bg-state-hover focus:outline-none",
);
